/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static #allowed() {
    return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  }

  static addProduct(productId) {
    if (!this.#allowed() || !/^[0-9]+$/.test(String(productId))) return;
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try { localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts)); } catch { /* Storage may be unavailable. */ }
  }

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch { /* Storage may be unavailable. */ }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    if (!this.#allowed()) return [];
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products.filter(id => typeof id === 'string' && /^[0-9]+$/.test(id)).slice(0, this.#MAX_PRODUCTS) : [];
    } catch { return []; }
  }
}

document.addEventListener('visitorConsentCollected', event => {
  if (event.detail?.preferencesAllowed === false) RecentlyViewed.clearProducts();
});
if (window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === false) {
  RecentlyViewed.clearProducts();
}
